import classes from './Popover.module.scss';
import * as React from 'react';
import * as PopoverPrimitive from '@radix-ui/react-popover';
import { cn } from '../../utils';
import Icon from '../Icon/Icon';

const Popover = PopoverPrimitive.Root;
const PopoverTrigger = PopoverPrimitive.Trigger;
const PopoverClose = PopoverPrimitive.Close;
type PopoverProps = PopoverPrimitive.PopoverProps;

const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> & { portal?: boolean }
>(
  (
    {
      className,
      align = 'start',
      side = 'bottom',
      sideOffset = 4,
      portal = true,
      children,
      ...props
    },
    ref
  ) => {
    const MaybePortal = portal ? PopoverPrimitive.Portal : React.Fragment;
    return (
      <MaybePortal>
        <PopoverPrimitive.Content
          data-testid='Popover-content'
          ref={ref}
          align={align}
          sideOffset={sideOffset}
          side={side}
          className={cn(
            classes['Content'],
            'sui-z-50 sui-w-fit sui-rounded sui-p-2 sui-bg-white sui-border sui-border-solid sui-border-neutral-border',
            className
          )}
          {...props}
        >
          {children}
          <PopoverPrimitive.Arrow
            className={cn(classes['Arrow'], 'sui-shadow-lg sui-border-neutral-border')}
          />
        </PopoverPrimitive.Content>
      </MaybePortal>
    );
  }
);
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

const PopoverCloseIcon = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.PopoverClose>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.PopoverClose>
>(({ className, ...props }, ref) => (
  <PopoverPrimitive.Close
    ref={ref}
    className={cn(
      classes['PopoverCloseIcon'],
      'sui-p-1 sui-text-neutral-text-weak sui-cursor-pointer'
    )}
    aria-label='Close'
    {...props}
  >
    <Icon size='small' name='close' />
  </PopoverPrimitive.Close>
));

export {
  Popover,
  PopoverTrigger,
  PopoverClose,
  PopoverContent,
  PopoverCloseIcon,
  PopoverProps,
};
